<template>
  <div class="run-schedule-description color-low mt-50">
    <span v-html="info" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  mode: {
    type: String,
    default: 'schedule'
  }
})

const items = [
  {
    value: 'schedule',
    info: 'Чтобы узнать расписание рейсов междугородней или международной перевозки - выберите город отправления и получения в списке. В верхней части сформированной таблицы будет указано время отправления рейса от терминала, а под ним - количество дней в пути. В нижней части таблицы указано время прибытия рейса на терминал в городе получения.'
  },
  {
    value: 'calculation',
    info: 'Данная форма поможет выбрать оптимальное время для отправки груза, чтобы получить его в необходимый срок. <ul class="public-list"><li>Укажите желаемую дату получения груза в поле "Дата доставки".</li><li>Выберите город отправления и получения из списка.</li></ul><p class="mt-10">В первой колонке таблицы будет указано когда груз необходимо сдать на терминал или водителю на адресе.</p> Во второй - когда груз прибудет в город получения. В последней - когда его можно получить на терминале или по адресу.'
  },
]

const info = computed((): String => {
  return items.find(v => v.value === props.mode)?.info || ''
})
</script>